import { set } from '@/utils/vuex'
const uuidv4 = require('uuid/v4')
function reformatHeure (value) {
  if (!value) {
    return value
  }
  let formatHeure = value.match(/^([0-1]?[0-9]|2[0-3])(:|h|H)([0-5][0-9])?$/)
  let formatNumerique = value.match(/^([0-1]?[0-9]|2[0-3])(\.)(\d+)$/)
  if (formatHeure) {
    return (formatHeure[1].length === 2 ? formatHeure[1] : '0' + formatHeure[1]) + 'h' + (formatHeure[3] ? formatHeure[3] : '00')
  }
  if (formatNumerique) {
    return (formatNumerique[1].length === 2 ? formatNumerique[1] : '0' + formatNumerique[1]) + 'h' + (parseFloat('0.' + formatNumerique[3]) * 60)
  }

  return value
}

function heureToFloat (value) {
  if (!value) {
    return null
  }
  let formatHeure = value.match(/^([0-1]?[0-9]|2[0-3])(:|h|H)([0-5][0-9])?$/)
  let formatNumerique = value.match(/^([0-1]?[0-9]|2[0-3])(\.)(\d+)$/)
  if (formatHeure) {
    return parseInt(formatHeure[1]) + (formatHeure[3] ? parseInt(formatHeure[3]) : 0) / 60
  }
  if (formatNumerique) {
    return parseFloat(value)
  }
  return null
}

export default {
  tempsRetrieveState: set('tempsRetrieveState'),
  tempsRetrieveRecords: set('tempsRetrieveRecords'),
  downloadExcelState: set('downloadExcelState'),
  addEmptyPlage: (state, params) => {
    if (!state.tempsRetrieveRecords || !state.tempsRetrieveRecords.clients) {
      throw new Error('No record found')
    }
    let clientFound = state.tempsRetrieveRecords.clients.filter(client => client.clientId === params.clientId)
    if (!clientFound.length) {
      throw new Error('No client found for id : ' + JSON.stringify(params.clientId))
    }
    let dossierFound = clientFound[0].dossiers.filter(dossier => dossier.dossierId === params.dossierId)
    if (!dossierFound.length) {
      throw new Error('No dossier found for id : ' + JSON.stringify(params.dossierId))
    }
    if (!dossierFound[0].plages) {
      dossierFound[0].plages = []
    }
    let plage = {
      isNew: true,
      plageId: uuidv4(),
      debut: null,
      fin: null
    }
    dossierFound[0].plages.push(plage)
    setTimeout(() => {
      plage.isNew = false
    }, 100)
    return state
  },
  updatePlageRecords: (state, params) => {
    let plageId = params.plageId
    let dossierId = params.dossierId
    let clientId = params.clientId
    if (!state.tempsRetrieveRecords) {
      return
    }
    state.tempsRetrieveRecords.clients.forEach(client => {
      if (client.clientId !== clientId) {
        return
      }
      client.dossiers.forEach(dossier => {
        if (dossier.dossierId !== dossierId) {
          return
        }
        dossier.plages.forEach(plage => {
          if (plage.plageId !== plageId) {
            return
          }
          if (params.reformatHeure) {
            plage.debut = reformatHeure(plage.debut)
            plage.fin = reformatHeure(plage.fin)
          }
          plage.erreur = !plage.tarifHoraire
          plage.duree = null
          let floatDebut = heureToFloat(reformatHeure(plage.debut))
          let floatFin = heureToFloat(reformatHeure(plage.fin))
          if ((floatDebut !== null && floatFin === null) || (floatDebut === null && floatFin !== null) || (floatDebut === null && floatFin === null)) {
            plage.erreur = true
          } else if (floatDebut !== null && floatFin !== null) {
            plage.duree = floatFin - floatDebut
            if (plage.duree < 0) {
              plage.erreur = true
              plage.duree = null
            }
          }
        })
        dossier.erreur = dossier.plages.filter(plage => plage.erreur).length > 0
        dossier.duree = null
        if (!dossier.erreur) {
          dossier.duree = 0
          dossier.plages.forEach(plage => {
            if (plage.duree !== null) {
              dossier.duree += plage.duree
            }
          })
        }
      })

      client.erreur = client.dossiers.filter(dossier => dossier.erreur).length > 0
      client.duree = null
      if (!client.erreur) {
        client.duree = 0
        client.dossiers.forEach(dossier => {
          if (dossier.duree !== null) {
            client.duree += dossier.duree
          }
        })
      }
    })
    return state
  },
  removePlageRecord: (state, params) => {
    let plageId = params.plageId
    let dossierId = params.dossierId
    let clientId = params.clientId
    if (!state.tempsRetrieveRecords) {
      return
    }
    state.tempsRetrieveRecords.clients.forEach(client => {
      if (client.clientId !== clientId) {
        return
      }
      client.dossiers.forEach(dossier => {
        if (dossier.dossierId !== dossierId) {
          return
        }
        let newPlages = []
        dossier.plages.forEach(plage => {
          if (plage.plageId === plageId) {
            return
          }
          newPlages.push(plage)
        })
        dossier.plages = newPlages
      })
    })
    return state
  },
  setLoadingPlageRecord: (state, params) => {
    let plageId = params.plageId
    let dossierId = params.dossierId
    let clientId = params.clientId
    if (!state.tempsRetrieveRecords) {
      return
    }
    state.tempsRetrieveRecords.clients.forEach(client => {
      if (client.clientId !== clientId) {
        return
      }
      client.dossiers.forEach(dossier => {
        if (dossier.dossierId !== dossierId) {
          return
        }
        dossier.plages.forEach(plage => {
          if (plage.plageId !== plageId) {
            return
          }
          plage.loading = params.loading
        })
      })
    })
    return state
  },
  removePlageRecordState: (state, params) => {
    let plageId = params.plageId
    let dossierId = params.dossierId
    let clientId = params.clientId
    if (!state.tempsRetrieveRecords) {
      return
    }
    state.tempsRetrieveRecords.clients.forEach(client => {
      if (client.clientId !== clientId) {
        return
      }
      client.dossiers.forEach(dossier => {
        if (dossier.dossierId !== dossierId) {
          return
        }
        dossier.plages.forEach(plage => {
          if (plage.plageId !== plageId) {
            return
          }
          plage.remove = params.state
        })
      })
    })
    return state
  }
}
